import { RightOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

const { Text } = Typography;

const StyledCard = styled.button`
  display: block;
  width: 100%;
  margin-top: 12px;
  text-align: left;
  cursor: pointer;
  padding: 12px 16px;
  background: ${props => props.theme.colorBgContainer};
  border: 2px solid ${props => props.theme.colorBorderSecondary};
  border-radius: ${props => props.theme.borderRadiusLG}px;
  font: inherit;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    border-color: ${props => props.theme.colorPrimary};
    background-color: ${props => props.theme.controlItemBgActive};
  }

  &:disabled {
    cursor: progress;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Avatar = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => props.theme.colorPrimary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
`;

const Content = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const TitleText = styled.div`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
  color: ${props => props.theme.colorText};
`;

const Subtitle = styled(Text)`
  display: block;
  margin-top: 2px;
  color: ${props => props.theme.colorTextSecondary};
  font-size: 0.875rem;
`;

const Chevron = styled(RightOutlined)`
  flex: 0 0 auto;
  color: ${props => props.theme.colorTextTertiary};
  font-size: 0.875rem;
`;

export interface ILegalEntityChoiceCardProps {
  /** Cerchio a sinistra: iniziali o icona. */
  avatar: React.ReactNode;
  title: React.ReactNode;
  /** Riga di metadata sotto al titolo (es. "P.IVA: 123 · Privata · Validata"). */
  subtitle?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  onSelect: () => void;
}

export function LegalEntityChoiceCard(
  props: Readonly<ILegalEntityChoiceCardProps>,
) {
  const {
    avatar,
    title,
    subtitle,
    loading = false,
    disabled = false,
    onSelect,
  } = props;

  return (
    <StyledCard type="button" disabled={loading || disabled} onClick={onSelect}>
      <Row>
        <Avatar aria-hidden="true">{avatar}</Avatar>
        <Content>
          <TitleText>{title}</TitleText>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Content>
        {!loading && <Chevron aria-hidden="true" />}
      </Row>
    </StyledCard>
  );
}
